import React, { Component, Fragment } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import isAuthenticated from '../common/utilities/authWrapper';
import Navbar from '../navbar/Navbar';
import Login from '../login/Login';
import NotFound from '../login/NotFound';
import Register1 from '../login/Register1';
import Register2 from '../login/Register2';
import Register3 from '../login/Register3';
import LoadingPage from '../common/layout/LoadingPage';
import Dashboard from '../../menus/dashboard/Index';
import AuthDashboard from '../login/AuthDashboard';

import ForgetPassword from '../login/ForgetPassword';
import ResetPassword from '../login/ResetPassword';
import ModalManager from '../modals/ModalManager';

const Profile = React.lazy(() => import('../../menus/profile/Index'));
const Presensi = React.lazy(() =>
  import('../../menus/_features/presensi/Index')
);
const Jadwal = React.lazy(() => import('../../menus/_features/jadwal/Index'));
const Pembelajaran = React.lazy(() =>
  import('../../menus/_features/pembelajaran/Index')
);
const MateriView = React.lazy(() =>
  import('../../menus/_features/pembelajaran/materi/ViewMateri')
);
const TugasView = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tugas/ViewTugas')
);
const TugasAnswerKey = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tugas/ViewAnswerKey')
);
const TugasSubmit = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tugas/ViewTugasSubmit')
);
const LatihanView = React.lazy(() =>
  import('../../menus/_features/pembelajaran/latihan/ViewLatihan')
);
const LatihanResult = React.lazy(() =>
  import('../../menus/_features/pembelajaran/latihan/ViewLatihanResult')
);
const LatihanReview = React.lazy(() =>
  import('../../menus/_features/pembelajaran/latihan/ViewLatihanReview')
);
const TesView = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tes/ViewTes')
);
const TesAnswerKey = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tes/ViewAnswerKey')
);
const TesSubmit = React.lazy(() =>
  import('../../menus/_features/pembelajaran/tes/ViewTesSubmit')
);
const Aktivitas = React.lazy(() =>
  import('../../menus/_features/aktivitas-belajar/Index')
);
const AktivitasView = React.lazy(() =>
  import('../../menus/_features/aktivitas-belajar/View')
);
const Notes = React.lazy(() => import('../../menus/_features/note/Index'));
const NoteView = React.lazy(() => import('../../menus/_features/note/View'));
const Raporbulanan = React.lazy(() =>
  import('../../menus/_features/rapor-bulanan/Index')
);
const RaporbulananView = React.lazy(() =>
  import('../../menus/_features/rapor-bulanan/View')
);
const Raporsemester = React.lazy(() =>
  import('../../menus/_features/rapor-semester/Index')
);
const RaporsemesterView = React.lazy(() =>
  import('../../menus/_features/rapor-semester/View')
);
const Raporketuntasan = React.lazy(() =>
  import('../../menus/_features/rapor-ketuntasan/Index')
);
const RaporketuntasanView = React.lazy(() =>
  import('../../menus/_features/rapor-ketuntasan/View')
);
const Raporprojek = React.lazy(() =>
  import('../../menus/_features/rapor-projek/Index')
);
const RaporprojekView = React.lazy(() =>
  import('../../menus/_features/rapor-projek/View')
);
const Rapormid = React.lazy(() =>
  import('../../menus/_features/rapor-mid/Index')
);
const RapormidView = React.lazy(() =>
  import('../../menus/_features/rapor-mid/View')
);
const Announcement = React.lazy(() =>
  import('../../menus/_features/announcement/Index')
);
const Kalender = React.lazy(() =>
  import('../../menus/_features/kalender/Index')
);
const Pesan = React.lazy(() => import('../../menus/_features/pesan/Index'));
const Pengaturan = React.lazy(() =>
  import('../../menus/_features/pengaturan-akun/Index')
);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // You can log error info here
    console.error('App Error:', error, info);
  }

  handleSessionStorageRemove(unamePass) {
    if (unamePass) {
      window.ReactNativeWebView.postMessage('logout');
    } else {
      sessionStorage.clear();
      window.location.reload();
    }
  }

  render() {
    let unamePass = localStorage.getItem('unamePass');
    if (this.state.hasError) {
      return (
        <div
          style={{
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: -100
          }}
        >
          <div>
            <h1 style={{ fontSize: 30, color: '#2863eb' }}>
              Something went wrong.
            </h1>
            <p
              style={{
                fontWeight: 500,
              }}
            >
              Sorry, we can't display the page. Something's missing.
            </p>
            <pre
              style={{
                display: 'flex',
                flexDirection: 'column',
                whiteSpace: 'pre-wrap',
                border: '1px solid #2863eb',
                margin: '20px 10px',
                borderRadius: 5,
                maxWidth: 600,
              }}
            >
              <p style={{ fontWeight: 600 }}>
                Note: Please contact admin for further support.
              </p>
              <details>
                <summary style={{ cursor: 'pointer', userSelect: 'none' }}>
                  Details Error
                </summary>
                {this.state.error?.toString()}
              </details>
            </pre>
            <button
              style={{
                background: '#2863eb',
                border: '1px solid #2863eb',
                borderRadius: 50,
                boxSizing: 'border-box',
                color: '#FFFFFF',
                cursor: 'pointer',
                display: 'inline-block',
                fontSize: 16,
                height: 40,
                padding: '3px 14px',
                textAlign: 'center',
              }}
              onClick={() => this.handleSessionStorageRemove(unamePass)}
            >
              Reset App
            </button>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <ModalManager />
        <Fragment>
          <Navbar />
          <React.Suspense fallback={<LoadingPage />}>
            <Switch key={this.props.location.key}>
              <Route exact path='/' component={Login} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/register' component={Register1} />
              <Route exact path='/register-2' component={Register2} />
              <Route exact path='/register-3' component={Register3} />
              <Route exact path='/forget-password' component={ForgetPassword} />
              <Route exact path='/reset-password' component={ResetPassword} />
              <Route exact path='/authdashboard' component={AuthDashboard} />
              <Route
                exact
                path='/dashboard'
                component={isAuthenticated(Dashboard)}
              />
              <Route path='/profil' component={isAuthenticated(Profile)} />
              <Route path='/presensi' component={isAuthenticated(Presensi)} />
              <Route path='/jadwal' component={isAuthenticated(Jadwal)} />
              <Route
                exact
                path='/pembelajaran/materi/:id'
                component={isAuthenticated(MateriView)}
              />
              <Route
                exact
                path='/pembelajaran/tugas/submit/:id'
                component={isAuthenticated(TugasSubmit)}
              />
              <Route
                exact
                path='/pembelajaran/tugas/kunci-jawaban/:id'
                component={isAuthenticated(TugasAnswerKey)}
              />
              <Route
                exact
                path='/pembelajaran/tugas/:id'
                component={isAuthenticated(TugasView)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/result/:id'
                component={isAuthenticated(LatihanResult)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/:id'
                component={isAuthenticated(LatihanView)}
              />
              <Route
                exact
                path='/pembelajaran/latihan/review/:id'
                component={isAuthenticated(LatihanReview)}
              />
              <Route
                exact
                path='/pembelajaran/tes/submit/:id'
                component={isAuthenticated(TesSubmit)}
              />
              <Route
                exact
                path='/pembelajaran/tes/kunci-jawaban/:id'
                component={isAuthenticated(TesAnswerKey)}
              />
              <Route
                exact
                path='/pembelajaran/tes/:id'
                component={isAuthenticated(TesView)}
              />
              <Route
                path='/pembelajaran'
                component={isAuthenticated(Pembelajaran)}
              />
              <Route
                exact
                path='/aktivitas-belajar'
                component={isAuthenticated(Aktivitas)}
              />
              <Route
                exact
                path='/aktivitas-belajar/:id'
                component={isAuthenticated(AktivitasView)}
              />
              <Route exact path='/notes' component={isAuthenticated(Notes)} />
              <Route
                exact
                path='/notes/:id'
                component={isAuthenticated(NoteView)}
              />
              <Route
                exact
                path='/rapor-bulanan'
                component={isAuthenticated(Raporbulanan)}
              />
              <Route
                exact
                path='/rapor-bulanan/:id'
                component={isAuthenticated(RaporbulananView)}
              />
              <Route
                exact
                path='/rapor-sem/:id'
                component={isAuthenticated(RaporsemesterView)}
              />
              <Route
                exact
                path='/rapor-sem'
                component={isAuthenticated(Raporsemester)}
              />
              <Route
                exact
                path='/rapor-ketuntasan/:id'
                component={isAuthenticated(RaporketuntasanView)}
              />
              <Route
                exact
                path='/rapor-ketuntasan'
                component={isAuthenticated(Raporketuntasan)}
              />
              <Route
                exact
                path='/rapor-projek'
                component={isAuthenticated(Raporprojek)}
              />
              <Route
                exact
                path='/rapor-projek/:id'
                component={isAuthenticated(RaporprojekView)}
              />
              <Route
                exact
                path='/rapor-mid'
                component={isAuthenticated(Rapormid)}
              />
              <Route
                exact
                path='/rapor-mid/:id'
                component={isAuthenticated(RapormidView)}
              />
              <Route
                exact
                path='/pengumuman'
                component={isAuthenticated(Announcement)}
              />
              <Route
                exact
                path='/kalender'
                component={isAuthenticated(Kalender)}
              />
              <Route exact path='/pesan' component={isAuthenticated(Pesan)} />
              <Route
                path='/pengaturan'
                component={isAuthenticated(Pengaturan)}
              />
              <Route path='/*' component={NotFound} />
            </Switch>
          </React.Suspense>
        </Fragment>
      </Fragment>
    );
  }
}

export default withRouter(App);
